import { memo } from 'react'
import { FormattedMessage } from 'react-intl'

import BodyText from 'LuxKit/Typography/BodyText'
import FormatDateTimeRange from 'components/utils/Formatters/FormatDateTimeRange'

interface Props {
  promotion: App.Property.RoomPromotion | App.Property.RatePromotion
}

function PropertyPromotionDetails({
  promotion: {
    travelFromIsoDate,
    travelToIsoDate,
    minimumLos,
  },
}: Props) {
  return <div>
    <BodyText variant="medium" weight="normal" colour="light-foreground-alt">
      <FormattedMessage
        id="kcA0DxTbcYz_atmnFIKM"
        defaultMessage="Travel between {dateRange}"
        description="Travel date range for promotional rate in the date selection or calendar picker"
        values={{
          dateRange: <FormatDateTimeRange startValue={travelFromIsoDate} endValue={travelToIsoDate} format="dmy-casual" />,
        }}
      />
    </BodyText>
    <BodyText variant="medium" weight="normal" colour="light-foreground-alt">
      <FormattedMessage
        id="RiNd4ADDAAOUYV9AvyOM"
        defaultMessage="Min stay: {nights, plural, one {# night} other {# nights}}"
        description="Minimum night stay requirement on the offer detail page"
        values={{ nights: minimumLos }}
      />
    </BodyText>
  </div>
}

export default memo(PropertyPromotionDetails)
